<template>
    <div class="statistic-dashboard">
        <el-tabs v-model="activeName" >
            <el-tab-pane label="Balance" name="balance">
                <StatisticDashboardBalance />
            </el-tab-pane>
            <el-tab-pane label="Deposit" name="deposit">
                <StatisticDashboardDeposit />
            </el-tab-pane>
            <el-tab-pane label="Withdrawal" name="withdraw">
                <StatisticDashboardWithdraw />
            </el-tab-pane>
            <el-tab-pane label="Mint & Burn" name="mint_burn">
                <StatisticDashboardMintBurn />
            </el-tab-pane>
            <el-tab-pane label="Exchange" name="exchange">
                <StatisticDashboardExchange />
            </el-tab-pane>
            <el-tab-pane label="Transfer" name="transfer">
                <StatisticDashboardTransfer />
            </el-tab-pane>
        </el-tabs>
        
    </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import StatisticDashboardBalance from "./StatisticDashboardBalance";
import StatisticDashboardDeposit from "./StatisticDashboardDeposit";
import StatisticDashboardWithdraw from "./StatisticDashboardWithdraw";
import StatisticDashboardMintBurn from "./StatisticDashboardMintBurn";
import StatisticDashboardExchange from "./StatisticDashboardExchange";
import StatisticDashboardTransfer from "./StatisticDashboardTransfer";
export default {
    name: "StatisticDashboard",
    components: {
        StatisticDashboardBalance,
        StatisticDashboardDeposit,
        StatisticDashboardWithdraw,
        StatisticDashboardMintBurn,
        StatisticDashboardExchange,
        StatisticDashboardTransfer,
    },
    data() {
        return {
            activeName: 'balance',
            withdraw: [],
            processing: false
        };
    },
    mounted() {
    },
    computed: {
        ...mapState({
            adminPerms: state => state.adminPerms
        })
    },
    methods: {
        ...mapActions(["request", "getError"]),
    }
};
</script>
<style scoped>
</style>
<style>
.statistic-dashboard {
    background-color: rgba(255,255,255,0.7);
    padding: 16px 20px;
}
.statisitc-dashboard-filter {
    margin-bottom: 16px;
    width: 100%;
}
.statistic-card {
    margin-bottom: 16px;
}
.statistic-card-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.statistic-card-item {
    padding: 16px;
    width: 25%;
    min-width: 250px;
}

.statistic-card-item h3{
    color: rgba(0,0,0,0.35);
}

.statistic-card-item-data {
    margin-bottom: 16px;
    line-height: 28px;
}

.statistic-card-item-data .value {
    font-size: 22px;
    line-height: 40px;
    padding: 0 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.statistic-card-item-data .title {
    border-top: 1px solid rgba(0,0,0,0.5);
    color: rgba(0,0,0,0.65);
    padding: 0 8px;
    font-size: 14px;
}

.statistic-card-item  {
    border-left: 1px solid rgba(0,0,0,0.1);
}
</style>